import {
  allowedActionsClient,
  AllowedActionsDto,
  LrwSessionAllowedActionsDto,
  SpeakingSessionAllowedActionsDto,
} from 'api/planning';
import { api } from '../api';
import {
  ALLOWED_ACTIONS_QUERY_TAG,
  LRW_SESSION_ALLOWED_ACTIONS_QUERY_TAG,
  SPEAKING_SESSION_ALLOWED_ACTIONS_QUERY_TAG,
} from 'store';

export const allowedActionsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllowedActions: builder.query<
      AllowedActionsDto,
      {
        organisationId: number | undefined;
        countryId: number | undefined;
        centreId: number | undefined;
        locationId: number | undefined;
      }
    >({
      query: (_navigationContext) => allowedActionsClient.getAllowedActions(),
      providesTags: () => [{ type: ALLOWED_ACTIONS_QUERY_TAG }],
    }),
    getAllowedLrwSessionActions: builder.query<
      LrwSessionAllowedActionsDto,
      { lrwSessionId: number; locationId: number | undefined }
    >({
      query: ({ lrwSessionId, locationId: _ }) =>
        allowedActionsClient.getAllowedLrwSessionActions(lrwSessionId, {
          customErrorHandling: (response) => response.status === 404,
        }),
      providesTags: () => [{ type: LRW_SESSION_ALLOWED_ACTIONS_QUERY_TAG }],
    }),
    getAllowedSpeakingSessionActions: builder.query<
      SpeakingSessionAllowedActionsDto,
      { speakingSessionId: number; locationId: number | undefined }
    >({
      query: ({ speakingSessionId, locationId: _ }) =>
        allowedActionsClient.getAllowedSpeakingSessionActions(speakingSessionId, {
          customErrorHandling: (response) => response.status === 404,
        }),
      providesTags: () => [{ type: SPEAKING_SESSION_ALLOWED_ACTIONS_QUERY_TAG }],
    }),
  }),
});

export const {
  useGetAllowedActionsQuery,
  useGetAllowedLrwSessionActionsQuery,
  useGetAllowedSpeakingSessionActionsQuery,
} = allowedActionsApi;
